import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getPerformance } from "firebase/performance";

const firebaseConfig = {
    apiKey: "AIzaSyDj15beAHb67Eo05PF9_86xmW79KFMaqjE",
    authDomain: "horoscope-web-app.firebaseapp.com",
    projectId: "horoscope-web-app",
    storageBucket: "horoscope-web-app.firebasestorage.app",
    messagingSenderId: "549640312286",
    appId: "1:549640312286:web:8dd7d3bffb3d2e034df94f",
    measurementId: "G-CN30X0ZC6R"
  };

const app = initializeApp(firebaseConfig);

const perf = getPerformance(app);

const analytics = getAnalytics(app);

export { app, perf, analytics };